// extracted by mini-css-extract-plugin
export default {"colorNhsukBlue":"#005eb8","colorNhsukWhite":"#fff"};